export { default as LoginForm } from './hocs';
